const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const COMPANY = {
    name: "NEBOORZY",
    legal: "NEBOORZY SAS",
    siren: "101 312 296",
    siret: "101 312 296 00011",
    rcs: "RCS Angers",
    address1: "2 rue de la Levée",
    address2: "49400 Saumur",
    phone: "[TÉLÉPHONE À COMPLÉTER]",
    email: "[EMAIL À COMPLÉTER]",
    zone: "France entière",
};

export const NAV_LINKS = [
    { id: "accueil", label: "Accueil", testid: "nav-link-accueil" },
    { id: "solutions", label: "Nos solutions", testid: "nav-link-solutions" },
    { id: "pourquoi", label: "Pourquoi NEBOORZY", testid: "nav-link-pourquoi" },
    { id: "besoin", label: "Votre besoin", testid: "nav-link-besoin" },
    { id: "contact", label: "Contact", testid: "nav-link-contact" },
];

export const NEED_TYPES = [
    "Location de matériel",
    "Location de véhicule",
    "Travaux BTP",
    "Électricité",
    "Plomberie",
    "Carrelage",
    "Rénovation",
    "Autre demande",
];

export const TIMINGS = [
    "Dès que possible",
    "Moins de 7 jours",
    "Dans le mois",
    "Projet à venir",
    "Je ne sais pas encore",
];

export const LEAD_STATUSES = ["Nouveau", "À rappeler", "RDV prévu", "Devis envoyé", "Traité"];

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1778042768125-d4f6b84e40e7?fm=jpg&q=70&w=2400&auto=format&fit=crop",
    presentation: "https://images.unsplash.com/photo-1758545814856-9cb6a286ecba?fm=jpg&q=70&w=1400&auto=format&fit=crop",
    equipment: "https://images.unsplash.com/photo-1603814744174-115311ad645e?fm=jpg&q=70&w=1200&auto=format&fit=crop",
    vehicles: "https://images.pexels.com/photos/13641048/pexels-photo-13641048.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    works: "https://images.pexels.com/photos/36035073/pexels-photo-36035073.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    band: "https://images.unsplash.com/photo-1773050832107-90cda3a03603?fm=jpg&q=70&w=2000&auto=format&fit=crop",
};

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
